// @flow

import server from 'server2';

import type { IApiService } from '../contracts';


export class ApiService
	implements IApiService {

	get any () {
		return this._clients.any;
	}

	get my () {
		return this._clients.my;
	}

	constructor () {
		this._clients = {
			any: server.any.api,
			my: server.my.api,
		};
	}
}

export class RestApiService
	extends ApiService
	implements IApiService {

	constructor () {
		super();

		this._clients = {
			any: server.any.rest,
			my: server.my.rest,
		};
	}
}

